/** Returns true if the string looks like a valid email address. */
export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
}

/** Returns true if the honeypot field is filled (bot signature). */
export function isHoneypotTripped(value: string | undefined): boolean {
  return typeof value === "string" && value.length > 0;
}
